var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _path15, _path16, _path17, _path18, _ellipse2, _ellipse3, _ellipse4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle2, _circle3, _circle4, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g3, _path46, _path47, _path48, _path49, _path50, _g4, _path51, _path52, _path53, _path54, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path55, _circle11, _g5, _path56, _path57;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "empty_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1620.69 827.03"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__linear-gradient",
    x1: 314.51,
    y1: 414.49,
    x2: 1339.74,
    y2: 414.49,
    gradientTransform: "matrix(1 0 0 -1 0 828)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3f6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c6ebfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__linear-gradient-2",
    x1: 67,
    y1: 478.88,
    x2: 136.96,
    y2: 478.88,
    xlinkHref: "#empty_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__linear-gradient-3",
    x1: 248.46,
    y1: 659.93,
    x2: 469.27,
    y2: 659.93,
    xlinkHref: "#empty_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__linear-gradient-4",
    x1: 66,
    y1: 190.5,
    x2: 142,
    y2: 190.5,
    xlinkHref: "#empty_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__linear-gradient-5",
    x1: 3,
    y1: 151.5,
    x2: 205,
    y2: 151.5,
    xlinkHref: "#empty_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, ".empty_svg__cls-10,.empty_svg__cls-14,.empty_svg__cls-17,.empty_svg__cls-6,.empty_svg__cls-9{isolation:isolate}.empty_svg__cls-12,.empty_svg__cls-6{fill:#9ebab7}.empty_svg__cls-14,.empty_svg__cls-41,.empty_svg__cls-6,.empty_svg__cls-9{opacity:.2}.empty_svg__cls-7{fill:#f5c924}.empty_svg__cls-17,.empty_svg__cls-20,.empty_svg__cls-9{fill:#fff}.empty_svg__cls-10{fill:#9fa1d1;opacity:.5}.empty_svg__cls-11{fill:#ecf3f2}.empty_svg__cls-14{fill:#6ab7cc}.empty_svg__cls-17{opacity:.25}.empty_svg__cls-22{fill:#64585c}.empty_svg__cls-24{fill:#537d6f}.empty_svg__cls-25{fill:#5b4c52}.empty_svg__cls-27{fill:#2f3446}.empty_svg__cls-30{fill:#bffac4}.empty_svg__cls-32{fill:#4c3941}.empty_svg__cls-34{opacity:.15}.empty_svg__cls-35{fill:#020202}.empty_svg__cls-36{fill:#f7f2e1}.empty_svg__cls-37{fill:#e6e2bd}.empty_svg__cls-38{fill:#e7a56b}.empty_svg__cls-40{fill:#c8935f}.empty_svg__cls-42{fill:#202020}.empty_svg__cls-43{fill:#66706f}.empty_svg__cls-46{fill:#ef473f}"))), /*#__PURE__*/React.createElement("g", {
    id: "empty_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty_svg__Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1562,391.59c0-20.08-22.23-57.6-49.66-57.6s-49.66,37.52-49.66,57.6a27.94,27.94,0,0,0,3.12,12.7,43.52,43.52,0,0,0-3.12,14.72c0,18.21,20.16,33,45,33s45-14.77,45-33a32.44,32.44,0,0,0-.56-5.73C1558.35,407.23,1562,399.72,1562,391.59Z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.09,
    fill: "#162126"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1307.36,384.34c-23.67-37.32-60.63-55.85-97-59.73S1137.46,330,1101.7,340C1054,353.3,998,365.29,962,321.19c-21.26-26.1-29.74-68.87-22.13-106.15,5.41-26.52,18.22-50.85,18-78.35-.23-28.51-15.09-54-33.46-68.37s-39.87-19.46-61-23.17c-47.21-8.31-95.91-10.76-141.9,5.35C678,3.54,616.75-12.29,563.34,9.87c-20.17,8.37-39.93,22.69-51.6,46.28-14.11,28.52-14.11,65.13-13.62,99.35q.79,55.31,1.58,110.6c.41,28.41.72,57.62-6.69,84.25-23.61,85-109.44,103.06-151.79,173.74C323.31,554,314.16,592.67,314.52,631a233.3,233.3,0,0,0,15,80.62C359.17,789,428.13,828.18,493,827s126.65-36,184.81-74.58c44-29.18,90-61.78,138.87-57.17,49.9,4.7,92.59,47.07,137.74,75.94,73.5,47,159.12,59,238.28,33.41,35-11.32,69.67-30.56,95.29-64.53,39.12-51.85,51.61-130.24,51.75-204C1339.84,482.3,1333.32,425.27,1307.36,384.34Z",
    fill: "url(#empty_svg__linear-gradient)",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.5,698a61,61,0,0,0-122,0Z",
    fill: "#87bafb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1378.5,637.8a61,61,0,0,1,54.91,60.2h16a61,61,0,0,0-61-61h0A59.86,59.86,0,0,0,1378.5,637.8Z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.1,
    fill: "#162126"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-6",
    d: "M1271.37 259.74V302H1374V267.24h34V225H1305.33v34.75zm128.71-.39h-86.85V232.89h86.85zm-120.81 8.29h86.85V294.1h-86.85zM230.37 345.74V388H333V353.24h34V311H264.33v34.75zm128.71-.39H272.23V318.89h86.85zm-120.81 8.29h86.85V380.1H238.27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-7",
    d: "M302.5,658H286V638h16.5a15.5,15.5,0,0,0,0-31H302V587h.5a35.5,35.5,0,0,1,0,71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-7",
    d: "M191.66,557H302.41a4.59,4.59,0,0,1,4.59,4.59h0v114.5A21.89,21.89,0,0,1,285.11,698H209a21.89,21.89,0,0,1-21.9-21.9h0V561.58a4.59,4.59,0,0,1,4.59-4.59h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,657.61v18c0,16.24-13.17,23.41-29.41,23.41l-68.11-1c-12.95,0-21.85-5-21.85-20C200,679.27,263,698,307,657.61Z",
    style: {
      isolation: "isolate"
    },
    fill: "#f59b3d",
    opacity: 0.4
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-9",
    d: "M307,561.58a4.6,4.6,0,0,0-4.6-4.58H191.65a4.59,4.59,0,0,0-4.59,4.59h0V571h13.57a7.94,7.94,0,0,0-2.41,5.5c0,5.56,6.61,10.07,14.77,10.07s14.77-4.51,14.77-10.07a7.94,7.94,0,0,0-2.41-5.5H307Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "empty_svg__cls-9",
    cx: 221.94,
    cy: 592.14,
    rx: 6.85,
    ry: 4.67,
    transform: "rotate(-20.62 221.997 592.222)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-10",
    d: "M82,622.31c-.23-.35-23.44-35.68-32.45-85.62-5.29-29.34-4.73-57.91,1.68-84.92,8-33.76,25.22-65.15,51.15-93.31l.74.68c-25.82,28-42.94,59.27-50.91,92.86-6.37,26.87-6.93,55.31-1.66,84.51,9,49.74,32.07,84.9,32.3,85.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-10",
    d: "M73 622.31c-.23-.35-23.44-35.68-32.45-85.62-5.29-29.34-4.73-57.91 1.68-84.92 8-33.76 25.22-65.15 51.15-93.31l.74.68c-25.82 28-42.94 59.27-50.91 92.86-6.37 26.87-6.93 55.31-1.66 84.51 9 49.74 32.07 84.9 32.3 85.25zM90 323l-1-.23c.1-.41 10.06-41.49 40.38-82.18 17.81-23.9 39.07-43 63.17-56.77 30.13-17.21 64.81-26.08 103.09-26.36v1c-38.09.28-72.61 9.11-102.58 26.22-24 13.69-45.13 32.7-62.86 56.48C100 281.68 90.07 322.59 90 323z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-10",
    d: "M100,333l-1-.23c.1-.41,10.06-41.49,40.38-82.18,17.81-23.9,39.07-43,63.17-56.77,30.13-17.21,64.81-26.08,103.09-26.36v1c-38.09.28-72.61,9.11-102.58,26.22-24,13.69-45.13,32.7-62.86,56.48C110,291.68,100.07,332.59,100,333Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-11",
    d: "M84.97 344.12H101.48V643.99H84.97z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M101.49 344.12H118V643.99H101.49z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-11",
    transform: "rotate(-36.34 204.128 258.161)",
    d: "M54.19 249.15H354.06V267.16H54.19z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    transform: "rotate(-36.07 213.021 272.918)",
    d: "M62.77 263.9H363.27V281.95H62.77z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.98,
    cy: 349.12,
    r: 34.98,
    fill: "url(#empty_svg__linear-gradient-2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-14",
    d: "M137,349.12a35,35,0,0,1-62.1,22.12A35,35,0,0,0,124.1,322,34.89,34.89,0,0,1,137,349.12Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.78,119.53l18.76-28.36A68.2,68.2,0,0,1,373,71.93l88.82,58.78a16.53,16.53,0,0,1,4.67,22.93L390.78,268.11a16.54,16.54,0,0,1-22.93,4.67L279,214A68.18,68.18,0,0,1,259.78,119.53Z",
    fill: "url(#empty_svg__linear-gradient-3)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-14",
    d: "M466.54,153.62,390.79,268.11a16.56,16.56,0,0,1-22.94,4.67l-65.5-43.34S401,269,453.42,125.1l8.45,5.59A16.55,16.55,0,0,1,466.54,153.62Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104,617h0a38,38,0,0,1,38,38h0v3H66v-3a38,38,0,0,1,38-38Z",
    fill: "url(#empty_svg__linear-gradient-4)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-14",
    d: "M142,655v3h-9v-3a38,38,0,0,0-33.5-37.73A37.61,37.61,0,0,1,104,617a38,38,0,0,1,38,38Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "empty_svg__cls-17",
    cx: 89.02,
    cy: 639.45,
    rx: 14.77,
    ry: 10.07,
    transform: "rotate(-54.24 89.02 639.453)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "empty_svg__cls-17",
    cx: 112.96,
    cy: 637.95,
    rx: 6.89,
    ry: 4.7,
    transform: "rotate(-60 112.96 637.949)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "empty_svg__cls-17",
    cx: 348.95,
    cy: 112.95,
    rx: 4.7,
    ry: 6.89,
    transform: "rotate(-45 348.955 112.948)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42,657H166a39,39,0,0,1,39,39H3A39,39,0,0,1,42,657Z",
    fill: "url(#empty_svg__linear-gradient-5)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-20",
    d: "M151.12,668H14.85A38.87,38.87,0,0,1,42,657H159.43v.1a8.62,8.62,0,0,1-6,10.59A8.5,8.5,0,0,1,151.12,668Z",
    opacity: 0.25
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-17",
    d: "M335.48,78.73a27,27,0,0,0-14.66-7.88l7-9.82a68,68,0,0,0-49.23,30.13l-18.77,28.37A67.94,67.94,0,0,0,249.9,171l57.92-81.82a29.09,29.09,0,0,0,6.79,10.38c8.45,8.45,20,10.63,25.74,4.87S343.94,87.18,335.48,78.73Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 799,
    cy: 733.22,
    rx: 465,
    ry: 28.01,
    style: {
      isolation: "isolate"
    },
    opacity: 0.26,
    fill: "#162126"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-22",
    d: "M1165.5,651.24h-718V204.82a8.33,8.33,0,0,1,8.33-8.33h701.35a8.33,8.33,0,0,1,8.33,8.33Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ed2a7",
    d: "M479.22 230.18H1134.79V624.9300000000001H479.22z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-24",
    d: "M481.32 619.49H1131.5V623.84H481.32zM480.74 234.49H1130.92V238.49H480.74z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-25",
    d: "M477.52 225.49H1135.49V233.49H477.52z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.54,635.49h-642a8,8,0,0,1-8-8h658A8,8,0,0,1,1127.54,635.49Z",
    fill: "#756b6f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-27",
    d: "M1131.48,234.49v389h-650v-389h650m4-4h-658v397h658Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-27",
    cx: 806.5,
    cy: 213.49,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.5,
    cy: 213.49,
    r: 2.5,
    fill: "#bd6965"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 806.5,
    cy: 213.49,
    r: 2.5,
    fill: "#1d2230"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-24",
    d: "M567 271.05H729V424.05H567zM748 488.05H1047V584.05H748z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-30",
    d: "M748 379.55H1047V475.55H748z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-24",
    d: "M748 271.05H1047V367.05H748z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-30",
    d: "M567 441.05H729V584.05H567z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-25",
    d: "M407.83,650.49H381.7c-5.58,0-9.67,4.73-8.5,9.73,4.87,20.73,25,36.27,49.09,36.27H1195.2c24.09,0,44.22-15.54,49.09-36.27,1.17-5-2.92-9.73-8.5-9.73H1224.4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-32",
    d: "M1244.3,660.22c-4.87,20.73-25,36.27-49.09,36.27H422.29c-24.09,0-44.22-15.54-49.09-36.27a7.52,7.52,0,0,1,1.64-6.64c6.81,18,25.48,30.91,47.45,30.91h772.92c22,0,40.64-12.92,47.45-30.91A7.52,7.52,0,0,1,1244.3,660.22Z",
    opacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-32",
    d: "M886.25,668.49h-155a18,18,0,0,1-18-18h191A18,18,0,0,1,886.25,668.49Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M904.5,650.49a18,18,0,0,1-18,18h-155a17.94,17.94,0,0,1-15.17-8.33A17.82,17.82,0,0,0,726,663H881a18,18,0,0,0,17.14-12.5Z",
    fill: "#423038"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-24",
    d: "M765.5 393.49H1030.5V400.49H765.5zM765.5 407.16H1030.5V414.16H765.5zM765.5 420.82H1030.5V427.82H765.5zM765.5 434.49H1030.5V441.49H765.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty_svg__cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-35",
    d: "M447.5 369.49H528.5V470.49H447.5z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-36",
    d: "M392.5 357.49H528.5V458.49H392.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-37",
    d: "M528.5 458.49L392.5 458.49 392.5 454.99 525 454.99 528.5 454.99"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "empty_svg__cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-35",
    transform: "rotate(-23.42 839.693 464.76)",
    d: "M679.92 395.82H999.3799999999999V533.6800000000001H679.92z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-36",
    transform: "rotate(-23.42 838.616 447.378)",
    d: "M672.92 378.44H1004.22V516.3H672.92z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-37",
    d: "M1017.97 444.78L713.97 576.46 712.07 572.08 1008.25 443.78 1016.07 440.39"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-22",
    d: "M410.5 377.49H488.5V383.49H410.5zM410.5 392.74H453.5V398.74H410.5zM410.5 423.24H453.5V429.24H410.5zM410.5 438.49H453.5V444.49H410.5zM410.5 407.99H505.5V413.99H410.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-38",
    d: "M1542,743H81c-28.17,0-51-4.83-51-33H1593C1593,738.16,1570.17,743,1542,743Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,714H1593a19,19,0,0,1-19,19H49a19,19,0,0,1-19-19Z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.7,
    fill: "#c8935f"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-38",
    d: "M9,696H1611a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9H0A9,9,0,0,1,9,696Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-40",
    d: "M1620.69,709.06c-1.23,2.82-6,4.93-11.69,4.93H11c-6.6,0-10-2.86-10-6.35v-5.29c0-3,4-5.54,9.31-6.19a3.49,3.49,0,0,0-.31,1.42v5.29c0,3.49,5.4,6.35,12,6.35H1618A22,22,0,0,0,1620.69,709.06Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-40",
    d: "M97.43 701.64A475 475 0 00145.14 704c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57L83.6 702.77c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM246.43 701.64A475 475 0 00294.14 704c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM590.43 701.64A475 475 0 00638.14 704c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM929.43 701.64A475 475 0 00977.14 704c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM1026.46 704.9a286.62 286.62 0 0028.41 4.1c3.66.35 6.63.58 8.68.75a13.67 13.67 0 013.19.41 12.81 12.81 0 01-3.21.19c-2.07 0-5-.06-8.74-.27a212.15 212.15 0 01-28.62-3.68l-8-1.62c-2.59-.56-5.09-1-7.49-1.35-4.79-.72-9.14-1.15-12.81-1.39-7.33-.48-11.89-.37-11.9-.62a11.88 11.88 0 013.2-.38c2.06-.12 5.06-.21 8.75-.09a125.63 125.63 0 0113 1.07c2.42.33 5 .73 7.57 1.27zM685.46 704.9a286.62 286.62 0 0028.41 4.1c3.66.35 6.63.58 8.68.75a13.67 13.67 0 013.19.41 12.81 12.81 0 01-3.21.19c-2.07 0-5-.06-8.74-.27a212.15 212.15 0 01-28.62-3.68l-8-1.62c-2.59-.56-5.09-1-7.49-1.35-4.79-.72-9.14-1.15-12.81-1.39-7.33-.48-11.89-.37-11.9-.62a11.88 11.88 0 013.2-.38c2.06-.12 5.06-.21 8.75-.09a125.63 125.63 0 0113 1.07c2.42.33 5 .73 7.57 1.27zM344.46 704.9a286.62 286.62 0 0028.41 4.1c3.66.35 6.63.58 8.68.75a13.67 13.67 0 013.19.41 12.81 12.81 0 01-3.21.19c-2.07 0-5-.06-8.74-.27a212.15 212.15 0 01-28.62-3.68l-8-1.62c-2.59-.56-5.09-1-7.49-1.35-4.79-.72-9.14-1.15-12.81-1.39-7.33-.48-11.89-.37-11.9-.62a11.88 11.88 0 013.2-.38c2.06-.12 5.06-.21 8.75-.09a125.63 125.63 0 0113 1.07c2.42.33 5 .73 7.57 1.27zM1217.46 704.9a286.62 286.62 0 0028.41 4.1c3.66.35 6.63.58 8.68.75a13.67 13.67 0 013.19.41 12.81 12.81 0 01-3.21.19c-2.07 0-5-.06-8.74-.27a212.15 212.15 0 01-28.62-3.68l-8-1.62c-2.59-.56-5.09-1-7.49-1.35-4.79-.72-9.14-1.15-12.81-1.39-7.33-.48-11.89-.37-11.9-.62a11.88 11.88 0 013.2-.38c2.06-.12 5.06-.21 8.75-.09a125.63 125.63 0 0113 1.07c2.42.33 5 .73 7.57 1.27zM1421.46 704.9a286.62 286.62 0 0028.41 4.1c3.66.35 6.63.58 8.68.75a13.67 13.67 0 013.19.41 12.81 12.81 0 01-3.21.19c-2.07 0-5-.06-8.74-.27a212.15 212.15 0 01-28.62-3.68l-8-1.62c-2.59-.56-5.09-1-7.49-1.35-4.79-.72-9.14-1.15-12.81-1.39-7.33-.48-11.89-.37-11.9-.62a11.88 11.88 0 013.2-.38c2.06-.12 5.06-.21 8.75-.09a125.63 125.63 0 0113 1.07c2.42.33 5 .73 7.57 1.27zM1288.43 701.64a475 475 0 0047.71 2.31c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM1107.43 701.64a475 475 0 0047.71 2.31c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM1532.43 701.64a475 475 0 0047.71 2.31c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM757.43 701.64A475 475 0 00805.14 704c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91zM426.43 701.64A475 475 0 00474.14 704c6.12 0 11.08-.09 14.5-.13s5.33 0 5.34.17-1.87.47-5.29.82-8.38.71-14.52.94a352.9 352.9 0 01-48-1.57l-13.57-1.42c-4.39-.51-8.6-.83-12.63-1-8.06-.44-15.33-.45-21.44-.28-12.22.36-19.76 1.26-19.81.86 0-.16 1.83-.61 5.23-1.13s8.34-1.14 14.49-1.53a210.9 210.9 0 0121.63-.27c4.07.16 8.35.43 12.74.91z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "empty_svg__cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-42",
    d: "M238 506.61c2.38-5.66 4.21-11 4.37-16a32.77 32.77 0 00-2.48-13.08c-1.41-3.69-2.86-6.64-3.75-8.75s-1.29-3.36-1-3.54 1.25.71 2.69 2.52a53.56 53.56 0 015.34 8.3 38.84 38.84 0 012.65 6.48 28.85 28.85 0 011.24 8.15 34.21 34.21 0 01-1.23 9 70.92 70.92 0 01-3.12 8.85c-1.2 2.91-2.43 5.67-3.49 8.33-.53 1.33-1 2.63-1.44 3.91l-.55 1.85-.43 1.85a29.29 29.29 0 00.28 13.17 19.47 19.47 0 002 4.58c.42.59.81 1.17 1.22 1.65a10.62 10.62 0 001.21 1.27c.41.34.76.66 1.08 1s.63.45.86.65c.46.38.7.67.64.84s-.41.2-1 .11a9 9 0 01-1.17-.26q-.64-.26-1.5-.66a14.33 14.33 0 01-1.74-1.12 18.1 18.1 0 01-1.81-1.69 19.12 19.12 0 01-3.14-5.12 29.56 29.56 0 01-1.51-15.16c.11-.71.26-1.43.4-2.16s.37-1.45.56-2.19c.43-1.42.9-2.84 1.42-4.25C235.65 512.26 236.86 509.45 238 506.61zM254.09 522.29c.93-3.72 2.09-7 2.92-10a48.35 48.35 0 001.62-7.9c.51-4.51-.29-7.37.41-7.67.3-.13 1 .43 1.64 1.73a15.87 15.87 0 011.56 6 32.77 32.77 0 01-.65 9c-.64 3.28-1.67 6.68-2.54 10.15a37.13 37.13 0 00-1.35 9.55 19.66 19.66 0 001.59 7.37c1.74 4 4.4 5.48 4.07 6.19q-.11.24-.72.21a5.15 5.15 0 01-1.68-.44 11.78 11.78 0 01-4.8-4.16 19.06 19.06 0 01-3.16-8.86A32.63 32.63 0 01254.09 522.29z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "empty_svg__cls-42",
    cx: 224.5,
    cy: 533.49,
    rx: 2.55,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-42",
    d: "M223.25,493.63a81.44,81.44,0,0,0,.4-13.7,47.64,47.64,0,0,0-1.9-10.86c-1.84-6-4.43-9.22-3.81-9.76.24-.22,1.21.3,2.6,1.66a23.63,23.63,0,0,1,4.59,6.8,39,39,0,0,1,3.21,11.71,65.6,65.6,0,0,1,0,14.69c-.56,5.12-1.42,9.87-2.17,14.15s-1.39,8.09-1.78,11.3c-.84,6.42-.79,10.48-1.53,10.58s-2-4-2.07-10.78a92.64,92.64,0,0,1,.73-11.77C222,503.27,222.72,498.54,223.25,493.63Z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1583.52,389.51a2.5,2.5,0,0,1-2-.93L1567.35,371l-27.43,14.79a2.5,2.5,0,1,1-2.5-4.33l.13-.07,31.08-16.77,16.83,20.82a2.5,2.5,0,0,1-1.94,4.07Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1581.14,370.66a2.5,2.5,0,0,1-2-.93L1565,352.13l-27.43,14.79a2.5,2.5,0,1,1-2.5-4.33l.13-.07,31.08-16.77,16.83,20.82a2.5,2.5,0,0,1-1.94,4.07Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1578.77 351.81a2.5 2.5 0 01-2-.93l-14.22-17.6-27.43 14.79a2.5 2.5 0 11-2.5-4.33l.13-.07 31.08-16.77 16.83 20.82a2.5 2.5 0 01-1.94 4.07zM1446.74 384a2.45 2.45 0 01-1.41-.44L1419.6 366l-16 16a2.5 2.5 0 11-3.6-3.47l.06-.06 18.94-19 29.15 19.93a2.5 2.5 0 01-1.41 4.56z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1451.07,365.47a2.45,2.45,0,0,1-1.41-.44l-25.73-17.59-16,16a2.5,2.5,0,1,1-3.6-3.47l.06-.06L1423.33,341l29.15,19.93a2.5,2.5,0,0,1-1.41,4.56Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1455.41 347a2.45 2.45 0 01-1.41-.44L1428.27 329l-16 16a2.5 2.5 0 11-3.6-3.47l.06-.06 18.92-18.95 29.15 19.93a2.5 2.5 0 01-1.41 4.56zM1514 446.51c0 8.55-8.91 15.48-19.89 15.48s-19.89-6.93-19.89-15.48 8.91-24.52 19.89-24.52S1514 438 1514 446.51z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "empty_svg__cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1493.5,351.49a4,4,0,0,1-4-4v-182a4,4,0,0,1,8,0v182A4,4,0,0,1,1493.5,351.49Z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-11",
    d: "M1546.32,372.71c0,18.38-23.65,33.28-52.82,33.28s-52.82-14.9-52.82-33.28S1464.33,320,1493.5,320,1546.32,354.33,1546.32,372.71Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-6",
    d: "M1546.32,372.71c0,18.38-23.65,33.28-52.82,33.28-1.41,0-2.82,0-4.21-.1,27.2-1.35,48.61-15.69,48.61-33.18s-21.41-49.43-48.61-52.48a37,37,0,0,1,4.21-.24C1522.67,320,1546.32,354.33,1546.32,372.71Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-11",
    d: "M1538.73,412.64c.17,15.39-19.49,28.08-43.91,28.34s-44.35-12-44.52-27.38,19.32-44.34,43.7-44.6S1538.57,397.26,1538.73,412.64Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-6",
    d: "M1533,395.22c-.57.39-1.15-2.23-1.75-1.85-8-12.17-21.4-20.38-36.65-20.38-15.43,0-29,8.48-36.93,20.82-.6-.36-1.18,2.27-1.75,1.9,7.55-13.37,22-26.72,38.68-26.72C1511,369,1525.35,382,1533,395.22Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-20",
    cx: 1474.5,
    cy: 412.99,
    r: 16
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-20",
    cx: 1513.5,
    cy: 412.99,
    r: 16
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-43",
    cx: 1505.5,
    cy: 412.99,
    r: 8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-20",
    cx: 1511,
    cy: 407.99,
    r: 5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-20",
    cx: 1472,
    cy: 407.99,
    r: 5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-43",
    cx: 1466.5,
    cy: 412.99,
    r: 8
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-20",
    d: "M1455.76 347a23.17 23.17 0 015.93-6c1.83-1.22 3.25-1.58 3.71-1.06.93 1.1-2.08 5.1-5.43 10s-6.07 9.1-7.43 8.62c-.65-.25-.81-1.7-.32-3.84A23.36 23.36 0 011455.76 347zM1474.07 331a11 11 0 015.44-1.06c1.46.15 2.37.69 2.46 1.38s-.6 1.43-1.66 2.14a41.1 41.1 0 01-8.44 3.89c-1.23.34-2.23.4-2.7-.13s-.29-1.56.55-2.77A11 11 0 011474.07 331z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "empty_svg__cls-20",
    cx: 1472,
    cy: 407.99,
    r: 5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "empty_svg__cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#98e2ca",
    d: "M1470.42 585.07H1562.42V677.07H1470.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-20",
    d: "M1516.42,604.57h0a26.49,26.49,0,0,1,26.5,26.5h0a26.49,26.49,0,0,1-26.5,26.5h0a26.49,26.49,0,0,1-26.5-26.5h0A26.49,26.49,0,0,1,1516.42,604.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-12",
    d: "M1509.42 623h0a4 4 0 014 4v8.17a4 4 0 01-4 4h0a4 4 0 01-4-4V627A4 4 0 011509.42 623zM1523.42 623h0a4 4 0 014 4v8.17a4 4 0 01-4 4h0a4 4 0 01-4-4V627A4 4 0 011523.42 623z"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-46",
    d: "M748.37 513.21l-18.9-40.89 30.31-14 3.2 6.92-22.06 10.19 4.19 9.07L765.64 475l3.18 6.89-20.53 9.48 5.15 11.13 22.84-10.56 3.18 6.89zM786.35 495.65l-18.9-40.88 12.36-5.71 20.31 24.46-5.56-31.28 12.38-5.72 18.9 40.88-7.67 3.54-14.88-32.18 6.76 35.93-7.94 3.68-23-28.45L794 492.11zM834 473.61l-18.9-40.88 13.25-6.13q7.53-3.48 10.1-3.92a11.82 11.82 0 017.73 1.28 14 14 0 016 6.87 14.7 14.7 0 011.56 7 12.34 12.34 0 01-1.61 5.63 13.06 13.06 0 01-3.38 3.92 51.75 51.75 0 01-8.29 4.54l-5.39 2.49 7.13 15.42zm-7.45-37.78l5.36 11.6 4.52-2.09q4.88-2.25 6.23-3.66a5.93 5.93 0 001.65-3.2 6.05 6.05 0 00-.53-3.61 5.78 5.78 0 00-3-3.07 6.21 6.21 0 00-4.15-.28 43.92 43.92 0 00-6.07 2.46zM881.33 451.75l-15.7-34-12.13 5.61-3.19-6.92 32.49-15 3.19 6.91-12.1 5.6 15.7 34zM917.75 434.92l-8-17.21L883.88 401l9.68-4.47 17.1 11.73 2-20.53 9.51-4.4L918.05 414 926 431.11z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "empty_svg__cls-46",
    d: "M736.6,543.48l-39.08-85.86L931,351.25l39.08,85.87Zm-33.49-83.71,35.58,78.13L964.52,435,928.94,357Z"
  })));
}

export default SvgEmpty;